import React from "react";

export const IconImage = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17.8"
            height="17.8"
            viewBox="0 0 17.8 17.8"
        >
            <g id="image" transform="translate(-0.6 -2.1)">
                <rect
                    id="Rectangle_733"
                    data-name="Rectangle 733"
                    width="16"
                    height="16"
                    rx="2"
                    transform="translate(1.5 3)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <circle
                    id="Ellipse_10"
                    data-name="Ellipse 10"
                    cx="1.5"
                    cy="1.5"
                    r="1.5"
                    transform="translate(4.467 6.467)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
                <path
                    id="Path_348"
                    data-name="Path 348"
                    d="M18.4,14.5,14.537,10,4,20"
                    transform="translate(-2 -2)"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="square"
                    strokeWidth="1.8"
                />
            </g>
        </svg>
    );
};
